import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import "./i18n";
import { getAdminUserDetails } from "store/actions/authSlice";

const isLogin = JSON.parse(localStorage.getItem("isLoggedIn"));
const isLoginRoute = window.location.pathname === "/login";

if (isLogin && !isLoginRoute) {
  store
    .dispatch(getAdminUserDetails())
    .then((action) => {
      const { statusCode, success, message } = action?.payload || {};
      // REDIRECT TO LOGIN IF DOESN'T HAVE PERMISSION
      if (statusCode === 401) {
        window.location.href = "/logout";
      }
    })
    .catch((err) => {});
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
